import {Component, ElementRef, Input, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatButton, MatFabButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {ApiService} from "../api.service";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {DatePipe} from "@angular/common";
import {Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {FormsModule} from "@angular/forms";
import {MatInput} from "@angular/material/input";
import {MatTooltip} from "@angular/material/tooltip";
import {AudioService} from "../audio.service";
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-aichat',
  imports: [
    MatProgressBar,
    MatIcon,
    MatFabButton,
    MatProgressSpinner,
    MatButton,
    MatButtonToggle,
    MatButtonToggleGroup,
    FormsModule,
    MatInput,
    MatTooltip
  ],
  templateUrl: './aichat.component.html',
  styleUrl: './aichat.component.css',
  providers: [DatePipe]
})
export class AichatComponent implements OnInit, OnDestroy {
  public qNo: number = 0;
  public qText: string = '';
  public agentText: string = '';
  public agentSpeaking: boolean = true;
  public respText: string = '';
  public instructions: string = 'Poslouchejte';
  public loading: boolean = false;
  public thinking: boolean = false;
  public progress: any = 0;
  public firstbubble: boolean = true;
  public followupId: number = 0;
  public isFinished: boolean = false;
  private key: string = '';
  private primaKey: string = '';
  private data: any;
  private interviewStartTime: string|null = '';
  private pc: any;
  private tts: number = 0;
  private speechStart: number = 0;
  private speechEnd: number = 0;
  private mediaRecorder: MediaRecorder|undefined;
  private recordedChunks: BlobPart[] = [];
  private recordingBlob: Blob|undefined;
  private gender: string = 'm';
  private silenceDuration: number = 4;
  private blockStreams: boolean = false;
  private tokenTime: any;
  private audioSource: any;
  private stream: any;
  private warning_timer: any;
  private unresponsive_timer: any;
  public paused: boolean = false;
  public userPaused: boolean = false;
  public pauseWarning: boolean = false;
  public speechResumed: boolean = false;
  public transcriptFailed: boolean = false;
  public prefersText: boolean = false;
  public canUseMic: boolean = false;
  private ttsStartTime: number | null = null;
  private idleAccum = 0;
  private idleActive = false;
  private idleStart = 0;
  private idleTimeoutHandle: any = null;
  private keyboardTts: number = 0;
  public isMobile: boolean = false;
  public timeForPause: boolean = false;
  public isSlow: boolean = false;
  @ViewChild('waveformCanvas') waveformCanvas!: ElementRef<HTMLCanvasElement>;

  @Input()
  aid: string = '';

  constructor(
    private api: ApiService,
    private ngZone: NgZone,
    private datePipe: DatePipe,
    private router: Router,
    private snack: MatSnackBar,
    private audioService: AudioService
  ) {
  }

  async ngOnInit() {
    if (window.innerWidth <= 768) {
      this.isMobile = true;
    }
    window.onresize = () => (this.isMobile = window.innerWidth <= 768);

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        this.pauseInterview(true);
      }
    });

    this.blockStreams = false;
    this.loading = true;
    await this.getOAIToken();
    this.primaKey = await this.api.getPrimaToken();
    this.canUseMic = await this.micCheck();
    if (!this.canUseMic) this.prefersText = true;
    const now = new Date();
    this.interviewStartTime = this.datePipe.transform(now, 'yyyy-MM-dd H:mm:ss');
    if (this.api.userData.sex_pronoun == 2) this.gender = 'f';
    if (this.api.userData.input == 1) this.prefersText = true;
    this.silenceDuration = Number(this.api.silenceDuration) / 1000;
    let input = 'mic';
    if (this.prefersText) input = 'keyboard';
    this.data = {
      "agent_id" : this.api.userData.respondent_id,
      "question_id": this.qNo,
      "interview_start_time": this.interviewStartTime,
      "gender": this.gender,
      "content": [],
      "input": input
    };
    await this.sendToPrima();
    this.loading = false;
    await this.speak();
    // await this.startRecording();
  }
  ngOnDestroy() {
    try {
      this.blockStreams = true;
      this.pc?.close();
      this.audioSource?.stop();
      this.stream?.getTracks().forEach((track: any) => track.stop());
      this.recordingBlob = undefined;
      clearTimeout(this.unresponsive_timer);
      clearTimeout(this.warning_timer);
    }
    catch (e) {
      console.log(e);
    }
  }

  async micCheck() {
    try {
      const mic = await navigator.mediaDevices.getUserMedia({
        audio: true
      });
      mic.getTracks().forEach((track: any) => track.stop());
      return await this.api.getCanUseMic();
    }
    catch (e) {
      console.log(e);
      return false;
    }
  }

  async getOAIToken() {
    console.log('Getting OAI Token');
    this.key = await this.api.getOpenAiToken();
    this.tokenTime = Date.now() + 480000;
  }


  async endRecording() {
    console.log('EndRecording');
    this.qText = '';
    this.agentSpeaking = true;
    this.instructions = 'Poslouchejte';
    if (this.prefersText) this.instructions = 'Čekejte prosím';
    if (!this.blockStreams) {
      await this.sendToPrima();
      await this.speak();
    }
  }
  async startRecording() {
    console.log('StartRecording');
    if (!this.blockStreams) {
      if (Date.now() >= this.tokenTime) {
        await this.getOAIToken();
      }
      // this.agentSpeaking = false;
      // this.instructions = 'Mluvte';
      if (this.prefersText) {
        await this.startTyping();
      }
      else await this.transcribeVoice();
    }
  }
  async startTyping() {
    setTimeout(()=>{
      document.getElementById('textInput')?.focus();
    })
    this.startTTSMeasurement();
    this.speechStart = Date.now();
    this.pc?.close();
    this.stream?.getTracks().forEach((track: any) => track.stop());
    this.recordingBlob = undefined;
    clearTimeout(this.unresponsive_timer);
    clearTimeout(this.warning_timer);
    this.ngZone.run(() => {
      this.agentSpeaking = false;
      this.paused = false;
      this.userPaused = false;
      this.thinking = false;
      this.pauseWarning = false;
      this.respText = '';
      this.instructions = 'Pište';
      this.speechResumed = false;
      this.transcriptFailed = false;
    });
  }
  async stopTyping() {
    this.respText = this.respText.trim();
    if (this.respText.length < 1) return;
    this.speechEnd = Date.now();
    this.stopTTSMeasurement();
    this.tts += (this.keyboardTts / 1000);
    this.ngZone.run(() => {
      this.thinking = true;
    });
    this.uploadAnswer(this.respText);
    await this.endRecording();
  }

  public btnMicClick() {
    // this.pc.close();
    // this.ngZone.run(() => {
    //   this.endRecording();
    // });
    console.log('btnclick');
  }

  public async pauseInterview(userPause: boolean = true) {
    console.log("paused");
    this.paused = true;
    this.userPaused = userPause;
    this.agentSpeaking = false;
    this.instructions = "Pozastaveno";
    this.ngOnDestroy();
  }

  public async unpauseInterview() {
    console.log("unpaused");
    this.thinking = true;
    this.transcriptFailed = false;
    await this.getOAIToken();
    this.primaKey = await this.api.getPrimaToken();
    this.blockStreams = false;
    if (this.isSlow) {
      this.isSlow = false;
      await this.endRecording();
    }
    else await this.startRecording();
  }

  public async transcribeVoice() {
    console.log('Transcribing');
    try {
      this.pc = new RTCPeerConnection();
      this.recordedChunks = [];

      this.stream = await navigator.mediaDevices.getUserMedia({
        audio: true
      });
      this.pc.addTrack(this.stream.getTracks()[0]);
      this.mediaRecorder = new MediaRecorder(this.stream, {
        mimeType: 'audio/webm'
      });
      this.mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          this.recordedChunks.push(event.data);
        }
      };
      this.mediaRecorder.onstop = () => {
        if (!this.blockStreams) {
          this.recordingBlob = new Blob(this.recordedChunks, {type: 'audio/webm'});
          this.uploadRecording();
        }
      };

      const dc = this.pc.createDataChannel("oai-events");
      dc.addEventListener("message", (e: any) => {
        // Realtime server events appear here!
        const d = JSON.parse(e.data);
        if (d.delta) this.respText += d.delta;
        if (d.type == "conversation.item.input_audio_transcription.completed") {
          this.respText = d.transcript;
          this.pc.close();
          this.speechEnd = Date.now();
          this.tts += ((this.speechEnd - this.speechStart) / 1000) - this.silenceDuration;
          this.mediaRecorder?.stop();
          this.ngZone.run(() => {
            this.thinking = true;
          });
          this.endRecording();
        }
        if (d.type == "transcription_session.created") {
          this.speechStart = Date.now();
          this.mediaRecorder?.start();
          this.ngZone.run(() => {
            this.agentSpeaking = false;
            this.paused = false;
            this.userPaused = false;
            this.thinking = false;
            this.pauseWarning = false;
            this.respText = '';
            this.instructions = 'Mluvte';
            this.speechResumed = false;
            this.transcriptFailed = false;
          });
          this.warning_timer = setTimeout(() => {
            this.pauseWarning = true;
            this.unresponsive_timer = setTimeout(() => {
              this.pauseInterview(false);
            }, 10000);
          }, 5000);
        }
        if (d.type == "input_audio_buffer.speech_started") {
          this.pauseWarning = false;
          this.speechResumed = true;
          clearTimeout(this.unresponsive_timer);
          clearTimeout(this.warning_timer);
        }
        if (d.type == "conversation.item.input_audio_transcription.failed") {
          this.transcriptFailed = true;
          clearTimeout(this.unresponsive_timer);
          clearTimeout(this.warning_timer);
          this.pauseInterview(false);
        }
        console.log(d);
      });

      const offer = await this.pc.createOffer();
      await this.pc.setLocalDescription(offer);

      const sdpResponse = await fetch(`${this.api.openAiUrl}`, {
        method: "POST",
        body: offer.sdp,
        headers: {
          Authorization: `Bearer ${this.key}`,
          "Content-Type": "application/sdp"
        }
      });
      if (!sdpResponse.ok) {
        const errorText = await sdpResponse.text();
        Sentry.logger.error('OpenAI Realtime API failed');
        throw new Error(`OpenAI Realtime API failed: ${sdpResponse.status} ${errorText}`);
      }

      const answer: RTCSessionDescriptionInit = {
        type: "answer",
        sdp: await sdpResponse.text(),
      };
      await this.pc.setRemoteDescription(answer);
    }
    catch (e) {
      console.error(e);
      this.transcriptFailed = true;
      this.pauseInterview(false);
    }
  }

  private async sendToPrima() {
    this.ngZone.run(() => {
      this.thinking = true;
    });
    console.log('Sending to prima');
    this.data.question_id = this.qNo;
    if (this.respText) this.data.content[this.data.content.length-1]['answer'] = this.respText;
    if (this.tts) this.data.content[this.data.content.length-1]['tts'] = this.tts;
    if (this.prefersText) this.data['input'] = 'keyboard';
    else this.data['input'] = 'mic';
    try {
      // this.data = await this.api.primaCall(this.primaKey, this.data);
      this.data = await this.api.primaCall(this.primaKey, this.data, status => {
        if (status.type === 'retry') {
          console.log(`Retrying request (attempt ${status.attempt})`);
          this.isSlow = true;
        }
        if (status.type === 'success') {
          this.data = status.data;
          this.isSlow = false;
          if (!this.tts) this.tts = this.data.content[this.data.content.length-1]['tts'];
          this.qText = this.data.content[this.data.content.length-1]['question'];
          this.followupId = this.data.content[this.data.content.length-1]['followup_id'];
          this.qNo = this.data.question_id;
          if (this.qNo < 0) this.finish();
          this.progress = this.data.progress_pct;
          this.timeForPause = this.data.time_for_pause;
          console.log('================PRIMA=============');
          console.log(this.data);
        }
      });
    }
    catch (e) {
      this.thinking = false;
      await this.pauseInterview(false);
      this.transcriptFailed = true;
      // this.isSlow = false;
      return;
    }
  }

  private async uploadRecording() {
    if (this.recordingBlob) this.api.uploadRecording(this.recordingBlob, this.qNo.toString(), this.followupId.toString());
  }
  private async uploadAnswer(text: string) {
    this.api.uploadAnswer(text, this.qNo.toString(), this.followupId.toString());
  }

  private async speak() {
    console.log('Start of speak()');
    if (!this.qText) return;
    const text = this.qText;
    if (this.prefersText) {
      this.ngZone.run(() => {
        this.firstbubble = false;
        this.thinking = false;
        this.agentText = this.qText;
        this.agentSpeaking = true;
      });
      await this.startRecording();
      return;
    }

    try {
      const response = await fetch(`${this.api.apiUrl}/auth/tts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': this.api.authToken
        },
        body: JSON.stringify({ text }),
      });

      const reader = response.body?.getReader();
      if (!reader) throw new Error('No stream');

      const chunks: Uint8Array[] = [];
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        if (value) chunks.push(value);
      }

      const totalLength = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
      const fullAudio = new Uint8Array(totalLength);
      let offset = 0;
      for (const chunk of chunks) {
        fullAudio.set(chunk, offset);
        offset += chunk.length;
      }

      const blob = new Blob([fullAudio.buffer], { type: 'audio/mpeg' });

      await this.audioService.unlock();

      console.log("agent speaking");

      this.ngZone.run(() => {
        this.firstbubble = false;
        this.thinking = false;
        this.agentText = this.qText;
        this.agentSpeaking = true;
      });

      await this.audioService.playBlob(blob, (audioEl) => {
        // Waveform setup starts here
        const audioCtx = new AudioContext();
        const source = audioCtx.createMediaElementSource(audioEl);
        const analyser = audioCtx.createAnalyser();
        source.connect(analyser);
        analyser.connect(audioCtx.destination);

        this.drawWaveform(analyser, this.waveformCanvas.nativeElement);

        if (audioCtx.state === 'suspended') {
          audioCtx.resume();
        }
      });

      await this.transcribeVoice();

    } catch (e) {
      console.log('Audio play failed', e);
    }
  }

  private drawWaveform(analyser: AnalyserNode, canvas: HTMLCanvasElement): void {
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const dataArray = new Uint8Array(analyser.frequencyBinCount);
    const width = canvas.width;
    const height = canvas.height;

    const gradient = ctx.createLinearGradient(0, 0, width, 0);
    gradient.addColorStop(0.0, "#00c3ff");
    gradient.addColorStop(0.25, "#ff5fc0");
    gradient.addColorStop(0.5, "#ff9a44");
    gradient.addColorStop(0.75, "#f06292");
    gradient.addColorStop(1.0, "#ff6f00");

    const draw = () => {
      // if (this.thinking) return;

      requestAnimationFrame(draw);
      analyser.getByteTimeDomainData(dataArray);

      ctx.clearRect(0, 0, width, height);
      ctx.lineWidth = 2;
      ctx.strokeStyle = gradient;
      ctx.beginPath();

      const sliceWidth = width / dataArray.length;
      let x = 0;

      for (let i = 0; i < dataArray.length; i++) {
        const v = dataArray[i] / 128.0;
        const y = v * height / 2;
        i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
        x += sliceWidth;
      }

      ctx.stroke();

      ctx.beginPath();
      x = 0;
      for (let i = 0; i < dataArray.length; i++) {
        const v = dataArray[i] / 128.0;
        const y = height - (v * height / 2);
        i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
        x += sliceWidth;
      }

      ctx.stroke();
    };

    draw();
  }

  private async finish() {
    this.pc?.close();
    this.isFinished = true;
    await this.api.setActivityState(this.aid, 'complete');
    this.snack.open('Aktivita úspěšně dokončena', 'Zavřít', {duration: 3000});
    // this.goToDashboard();
  }
  goToDashboard() {
    this.router.navigate(['dashboard']);
  }
  async changeInput() {
    this.pc?.close();
    this.stream?.getTracks().forEach((track: any) => track.stop());
    this.recordingBlob = undefined;
    clearTimeout(this.unresponsive_timer);
    clearTimeout(this.warning_timer);
    console.log(this.prefersText);
    await this.api.changeInput(this.prefersText);
    if (!this.agentSpeaking && !this.thinking && !this.paused) await this.startRecording();
  }

  private startTTSMeasurement() {
    this.ttsStartTime = Date.now();
    this.idleAccum = 0;
    this.idleActive = false;
    if (this.idleTimeoutHandle) {
      clearTimeout(this.idleTimeoutHandle);
      this.idleTimeoutHandle = null;
    }
    this.armIdleTimeout();
  }
  private armIdleTimeout() {
    if (this.idleTimeoutHandle) clearTimeout(this.idleTimeoutHandle);
    this.idleTimeoutHandle = setTimeout(() => {
      this.idleActive = true;
      this.idleStart = Date.now();
    }, this.silenceDuration * 1000);
  }

  private stopTTSMeasurement() {
    const now = Date.now();

    if (this.idleActive) {
      this.idleAccum += now - this.idleStart;
      this.idleActive = false;
    }

    if (this.idleTimeoutHandle) {
      clearTimeout(this.idleTimeoutHandle);
      this.idleTimeoutHandle = null;
    }

    const total = this.ttsStartTime ? (now - this.ttsStartTime) : 0;
    const effective = Math.max(0, total - this.idleAccum);

    this.keyboardTts = effective; // ms
    console.log({ total, idle: this.idleAccum, effective });
  }

  public onKeyboardInput() {
    const now = Date.now();
    if (this.idleActive) {
      this.idleAccum += now - this.idleStart;
      this.idleActive = false;
    }
    this.armIdleTimeout();
  }

}
